import { SearchTerm } from "./SearchTerm";

const TnaTransactionSearch: SearchTerm[] = [
    {
        heading: "Description",
        accessor: "biometricType",
        searchOnName: "bioType.trnName",
        translationKey: "description"
    },
    {
        heading: "Display Name",
        accessor: "displayName",
        searchOnName: "btrDisplayname",
        translationKey: "displayName"
    },
    {
        heading: "First Name",
        accessor: "firstName",
        searchOnName: "btrFirstname",
        translationKey: "firstName"
    },
    {
        heading: "Last Name",
        accessor: "lastName",
        searchOnName: "btrLastname",
        translationKey: "lastName"
    },
    {
        heading: "Serial Address",
        accessor: "serialAddress",
        searchOnName: "btrSerial",
        translationKey: "serialAddress"
    },
    {
        heading: "Type",
        accessor: "biometricMake",
        searchOnName: "bioType.bioMake",
        translationKey: "type"
    },
    {
        heading: "Id Number",
        accessor: "idNumber",
        searchOnName: "btrIdnumber",
        translationKey: "uniqueIdentifier"
    },
    {
        heading: "User ID Csn",
        accessor: "userIdCsn",
        searchOnName: "btrCol1",
        translationKey: "userIdCsn"
    },
];

export default TnaTransactionSearch;
